import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "h-screen bg-gray-100" }
const _hoisted_2 = { class: "flex justify-center h-full" }
const _hoisted_3 = { class: "w-11/12 md:w-1/2 card-outlined overflow-hidden shadow-lg my-3" }
const _hoisted_4 = {
  key: 1,
  class: "text-xl mb-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Start = _resolveComponent("Start")!
  const _component_Result = _resolveComponent("Result")!
  const _component_Proceeding = _resolveComponent("Proceeding")!
  const _component_Tallying = _resolveComponent("Tallying")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.state.loading)
          ? (_openBlock(), _createBlock(_component_Loading, {
              key: 0,
              loading: _ctx.state.loading
            }, null, 8, ["loading"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.surveyData.started==0)
                ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
                    _createVNode(_component_Start, {
                      title: _ctx.surveyData.title,
                      onReload: _ctx.reload
                    }, null, 8, ["title", "onReload"])
                  ])
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.surveyData.finished==1)
                      ? (_openBlock(), _createBlock(_component_Result, {
                          key: 0,
                          title: _ctx.surveyData.title,
                          loading: _ctx.state.loading,
                          userRunk: _ctx.state.userRunk
                        }, null, 8, ["title", "loading", "userRunk"]))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.surveyData.number <= _ctx.surveyData.maxNum)
                            ? (_openBlock(), _createBlock(_component_Proceeding, {
                                key: 0,
                                title: _ctx.surveyData.title,
                                loading: _ctx.state.loading,
                                number: _ctx.surveyData.number,
                                btnConf: _ctx.state.btnConf,
                                onAnswer: _ctx.answer
                              }, null, 8, ["title", "loading", "number", "btnConf", "onAnswer"]))
                            : (_openBlock(), _createBlock(_component_Tallying, {
                                key: 1,
                                title: _ctx.surveyData.title,
                                onReload: _ctx.reload
                              }, null, 8, ["title", "onReload"]))
                        ], 64))
                  ], 64))
            ]))
      ])
    ])
  ]))
}